import { useState, useEffect } from "react";
//API
import { axiosWithAuth } from "../../../../api/axiosConfig";
import {
  urlGetProducts,
  urlCreateProducts,
  urlEditProducts,
  urlGetTiposProducts,
  urlCreateTiposProducts,
  urlEditTiposProducts,
} from "../../../../api/URLs/entidadesSecundarias/productos";
//HOOKS
import { useModal } from "../../../../hooks/useModal";
//FORMIK & YUP
import { Formik } from "formik";
import { productsSchema } from "../../../../schemas/Camiones/EntidadesSecundarias/productsSchema";
//BOOTSTRAP
import { Button, Form, FormGroup, ListGroup } from "react-bootstrap";
//COMPONENTS
//--Modal
import ModalAlert from "../../../../components/Modals/ModalAlert";
//--Table
import Table from "../../../../components/Tools/Tables/Table/Table";
//--Basic
import BoxContainer from "../../../../components/Tools/Cards/BoxContainer/BoxContainer";
import CenterSpinner from "../../../../components/Tools/Basics/Spinner";
import CustomBtn from "../../../../components/Tools/Basics/CustomBtn";

const FormProducts = () => {
  //useModal
  const {
    showModal,
    modalType,
    msjModal,
    handleClose,
    handleError,
    handleSucces,
  } = useModal();

  //States - Productos
  const [reForm, setReForm] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingTable, setLoadingTable] = useState(false);
  const [products, setProducts] = useState([]);
  const [product, setProduct] = useState(null);

  // --- NUEVO: States - Tipos de Productos ---
  const [tiposProductos, setTiposProductos] = useState([]);
  const [tipoProduct, setTipoProduct] = useState(null);
  const [reFormTipos, setReFormTipos] = useState(false);
  const [loadingTipos, setLoadingTipos] = useState(false);

  //INITIAL VALUES PRODUCTOS
  let newValues = { desc_product: "" };
  let updateValues = { desc_product: product?.desc_producto || "" };
  const initialValues = product ? updateValues : newValues;

  // --- NUEVO: INITIAL VALUES TIPOS PRODUCTOS ---
  let newValuesTipo = { desc_tipo: "" };
  let updateValuesTipo = { desc_tipo: tipoProduct?.desc_tipo || "" };
  const initialValuesTipo = tipoProduct ? updateValuesTipo : newValuesTipo;

  //GET PRODUCTOS
  const getProducts = async () => {
    try {
      setLoadingTable(true);
      const api_response = await axiosWithAuth.get(urlGetProducts);
      setProducts(api_response.data);
    } catch (error) {
      const auxError = error.response?.data?.msj || "Error del servidor";
      handleError(auxError);
    } finally {
      setLoadingTable(false);
    }
  };

  // --- NUEVO: GET TIPOS PRODUCTOS ---
  const getTiposProductos = async () => {
    try {
      const api_response = await axiosWithAuth.get(urlGetTiposProducts);
      setTiposProductos(api_response.data);
    } catch (error) {
      console.error(error);
    }
  };

  //POST - PUT PRODUCTOS
  const handleSubmit = async (values) => {
    try {
      setLoading(true);
      let api_response;
      if (!product) {
        api_response = await axiosWithAuth.post(urlCreateProducts, values);
      } else {
        api_response = await axiosWithAuth.put(urlEditProducts, {
          ...values,
          id: product.id,
        });
      }
      handleSucces(api_response);
      setReForm(!reForm);
    } catch (error) {
      const auxError = error.response?.data?.msj || "Error del servidor";
      handleError(auxError);
    } finally {
      setProduct(null);
      setLoading(false);
    }
  };

  // --- NUEVO: POST - PUT TIPOS PRODUCTOS ---
  const handleSubmitTipo = async (values, { resetForm }) => {
    try {
      setLoadingTipos(true);
      let api_response;
      if (!tipoProduct) {
        api_response = await axiosWithAuth.post(urlCreateTiposProducts, values);
      } else {
        api_response = await axiosWithAuth.put(urlEditTiposProducts, {
          ...values,
          id: tipoProduct.id,
        });
      }
      handleSucces(api_response);
      setReFormTipos(!reFormTipos);
      resetForm();
    } catch (error) {
      const auxError = error.response?.data?.msj || "Error del servidor";
      handleError(auxError);
    } finally {
      setTipoProduct(null);
      setLoadingTipos(false);
    }
  };

  // --- NUEVO: VINCULAR TIPO A PRODUCTO ---
  const handleVincular = async (idTipoProduct) => {
    if (!product) return;
    try {
      // Usamos la ruta base de tu API directamente o puedes crear una variable en tu archivo de URLs
      const api_response = await axiosWithAuth.put(
        `/api/products/${product.id}/tipos/${idTipoProduct}`,
      );
      handleSucces(api_response);
      getProducts();
      getTiposProductos();
      setProduct(null);
      setTipoProduct(null);
      setReForm(!reForm);
    } catch (error) {
      const auxError = error.response?.data?.msj || "Error al vincular";
      handleError(auxError);
    }
  };

  //HANDLE EDIT
  const handleEdit = (p) => {
    setProduct(p);
    setReForm(!reForm);
  };

  // --- NUEVO: HANDLE EDIT TIPO ---
  const handleEditTipo = (tp) => {
    setTipoProduct(tp);
  };

  //BOTONES
  const actions = (p) => {
    return <CustomBtn type={"edit_table"} onClick={() => handleEdit(p)} />;
  };

  //COLUMNAS
  const columns = [
    { header: "Id", field: "id" },
    { header: "Producto", field: "desc_producto" },
    { header: "Tipo", field: "desc_tipo" },
    { header: "Editar", body: actions },
  ];

  useEffect(() => {
    getProducts();
  }, [reForm]);

  // --- NUEVO: useEffect para Tipos ---
  useEffect(() => {
    getTiposProductos();
  }, [reFormTipos]);

  return (
    <div className="row">
      {/* TABLA PRINCIPAL DE PRODUCTOS */}
      <div className="col-md-8">
        <BoxContainer maxSize={"lg"} minSize={"lg"}>
          <Table
            data={products}
            columns={columns}
            keyProp={"id"}
            title={"Productos"}
            scrollSize={"lg"}
            textFilter
            loading={loadingTable}
          />
        </BoxContainer>
      </div>

      {/* SECCIÓN DERECHA: FORMULARIOS Y LISTA */}
      <div className="col-md-4">
        {/* --- FORMULARIO DE PRODUCTOS --- */}
        {!loading ? (
          <>
            <div
              className={`alert alert-${product ? "success" : "primary"} w-100`}
              role="alert"
            >
              {`${product ? "Modificar" : "Agregar nuevo"} Producto ${
                product ? product.desc_producto : ""
              }`}
            </div>
            <Formik
              enableReinitialize
              validationSchema={productsSchema}
              initialValues={initialValues}
              onSubmit={handleSubmit}
            >
              {({
                handleChange,
                handleBlur,
                handleSubmit,
                values,
                errors,
                touched,
                isSubmitting,
              }) => (
                <Form onSubmit={handleSubmit} className="shadow-none mb-4">
                  <FormGroup>
                    <Form.Control
                      type="text"
                      placeholder="Ingresar producto"
                      name="desc_product"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.desc_product}
                      isInvalid={
                        errors.desc_product &&
                        touched.desc_product &&
                        errors.desc_product
                      }
                    />
                  </FormGroup>
                  <Button
                    variant={product ? "success" : "primary"}
                    className="mt-3 w-100"
                    type="submit"
                    disabled={isSubmitting}
                  >
                    {product ? "Modificar Producto" : "Agregar Producto"}
                  </Button>
                </Form>
              )}
            </Formik>
          </>
        ) : (
          <CenterSpinner />
        )}

        <hr />

        {/* --- NUEVO: FORMULARIO Y LISTA DE TIPOS DE PRODUCTOS --- */}
        {!loadingTipos ? (
          <>
            <div
              className={`alert alert-${tipoProduct ? "warning" : "success"} w-100 mt-2 py-2`}
              role="alert"
            >
              {`${tipoProduct ? "Modificar" : "Agregar nuevo"} Tipo de Producto`}
            </div>

            {/* FORMULARIO TIPOS */}
            <Formik
              enableReinitialize
              // validationSchema={tiposProductsSchema} // <-- Agrega tu schema si tienes uno
              initialValues={initialValuesTipo}
              onSubmit={handleSubmitTipo}
            >
              {({
                handleChange,
                handleBlur,
                handleSubmit,
                values,
                isSubmitting,
              }) => (
                <Form
                  onSubmit={handleSubmit}
                  className="shadow-none mb-3 d-flex gap-2"
                >
                  <Form.Control
                    type="text"
                    placeholder="Descripción del tipo"
                    name="desc_tipo"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.desc_tipo}
                  />
                  <Button
                    variant="success"
                    type="submit"
                    disabled={isSubmitting || !values.desc_tipo.trim()}
                  >
                    {tipoProduct ? "✓" : "+"}
                  </Button>
                  {tipoProduct && (
                    <Button
                      variant="danger"
                      onClick={() => setTipoProduct(null)}
                    >
                      X
                    </Button>
                  )}
                </Form>
              )}
            </Formik>

            {/* LISTA DE TIPOS Y VINCULACIÓN */}
            <h6 className="mt-3 mb-2 text-muted">Tipos de Productos</h6>
            <ListGroup style={{ maxHeight: "250px", overflowY: "auto" }}>
              {tiposProductos.length > 0 ? (
                tiposProductos.map((tp) => (
                  <ListGroup.Item
                    key={tp.id}
                    className="d-flex justify-content-between align-items-center p-2"
                  >
                    <div className="d-flex align-items-center gap-2">
                      <span className="fw-medium text-dark">
                        {tp.desc_tipo}
                      </span>
                      <CustomBtn
                        type={"edit_table"}
                        onClick={() => handleEditTipo(tp)}
                        title="Editar tipo"
                      />
                    </div>

                    {/* Botón para vincular (Solo visible si hay un Producto seleccionado arriba) */}
                    {product && (
                      <Button
                        variant="outline-primary"
                        size="sm"
                        onClick={() => handleVincular(tp.id)}
                        title={`Vincular a ${product.desc_producto}`}
                      >
                        Vincular
                      </Button>
                    )}
                  </ListGroup.Item>
                ))
              ) : (
                <small className="text-muted text-center py-2">
                  No hay tipos cargados.
                </small>
              )}
            </ListGroup>
            {product && (
              <small className="text-success d-block mt-2">
                * Selecciona "Vincular" para asociar un tipo al producto:{" "}
                <b>{product.desc_producto}</b>
              </small>
            )}
          </>
        ) : (
          <CenterSpinner />
        )}
      </div>

      {/* MODAL ALERTS */}
      <ModalAlert
        show={showModal}
        type={modalType}
        msj={msjModal}
        handleClose={handleClose}
      />
    </div>
  );
};

export default FormProducts;
